import { apiPost, apiGet, getProNameHeader } from './brainApi';
import { sendToFullStory, possibleProStatuses } from './helper';

const getSSOUserDetails = () => {
const hashParams = window.location.hash.substr(1); // Remove the '#' symbol
const searchParams = new URLSearchParams(hashParams);
const username = decodeURIComponent(searchParams.get('username'));
const ssoToken = decodeURIComponent(searchParams.get('ssoToken'));
const deviceId = 'Desktop';

const payload = { email: username, sso_token: ssoToken, device_id: deviceId };

// Perform API requests or any other necessary operations using the extracted parameters
return apiPost('/technician-login', payload)
.then(response => {
const { token, user, employee } = response;
    if (token) {
        localStorage.setItem('token', token);
        localStorage.setItem('user', JSON.stringify(user));
        localStorage.setItem('employee', JSON.stringify(employee));
        localStorage.setItem('theme', 0);
        sendToFullStory(JSON.stringify(user));
    } else {
        return Promise.reject({ message: response.Message });
    }
    })
    .then(() => apiGet(`/pro/${getProNameHeader()}`))
    .then(pro => {
    if (pro.status === possibleProStatuses.churned)
        return Promise.reject({
        message:
            'Your account has been deactivated. Please contact success@getzippity.com for assistance.',
        });
    return Promise.resolve();
    })
    .catch((error) => Promise.reject(error));
};


export default getSSOUserDetails;